import clientApi from '~/clientApi';
import { MediaPackContent } from '~/types';

interface PatchMediaPackArgs {
  id: string;
  data: any;
  _impersonateOnce?: string;
}

export const patchMediaPack = ({
  id,
  data,
  _impersonateOnce,
}: PatchMediaPackArgs) => {
  return clientApi.mediaPacks.update({
    _impersonateOnce,
    id,
    ...data,
    ...(data.contents && {
      contents: data.contents.map(
        ({ _id }: MediaPackContent & { _id: string }) => _id,
      ),
    }),
    ...(data.tiktokContents && {
      tiktokContents: data.tiktokContents,
    }),
    ...(data.ytContents && {
      ytContents: data.ytContents,
    }),
  });
};
